import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import '../../coachingSummary/capGuidance/CapGuidance.scss';

interface CoachingGuidanceProps {
    isCoachingGuidanceVisible: boolean;
    onHide: () => void;
};

const CoachingGuidance = ({ isCoachingGuidanceVisible, onHide }: Readonly<CoachingGuidanceProps>) => {
    const handleHide = () => {
        onHide();
    };
    const handlePrint = () => {
        const dialogContent = document.getElementById('CoachingGuidance');
        if (dialogContent) {
            dialogContent.classList.add('print-mode');
            setTimeout(() => {
                window.print();
            }, 100);
        }
    }
    return (
        <Dialog
            header={<div className="header-coaching" id='CoachingGuidance'>
                <h3>Coaching Observations</h3>
                <div>
                    <Button
                        data-testid='printButton'
                        icon="pi pi-print"
                        className="btn-primary me-2"
                        onClick={handlePrint}
                    />
                    <Button
                        type="button"
                        data-testid='closeButton'
                        className="btn-primary"
                        label="Return to Coaching Observations"
                        aria-label="Return to Coaching Observations"
                        role="button"
                        onClick={handleHide} />
                </div>
            </div>}
            visible={isCoachingGuidanceVisible}
            onHide={handleHide}
            closable={false}
            className="card shadow bg-body rounded mt-4 border-0 p-0 w-65"
            modal
            draggable={false}
            resizable={false}
            style={{ width: '900px', height: '440px' }}>
            <hr />
            <div style={{ fontWeight: 400, marginLeft: '3px' }}>
                <p>
                If you choose to complete CAPs for your Team Leads, this is separate from the Coaching Observation and Coaching Follow Up process and requirements.</p> 
<p>
                Conducting a 1:1 touch base – is considered a Discussion Log categorized as ‘Discussion’ and is also separate from the Coaching Observation and Coaching Follow up process and requirements.</p>
                <ul >
                    <li><b>Coaching Observation/Coaching Follow Up:</b>
                        <ul>
                            <li>
                            Requirement: 2x the total number of TL’s with:
                            </li>
                            <li>
                            At least 1 Coaching Observation per TL per month
                            </li>
                            <li>
                            Coaching Observations should be prioritized by performance focusing on TL’s that need the attention earlier in the month
                            </li>
                            <li>
                            Balance of requirement is to be completed as a Coaching Follow Up
                            
                            <ul>
                                <li>
                                The Coaching Follow up is at the discretion of the manager and will be based on identifying those that will make the largest impact to the team overall including:
                                <ul style={{listStyleType:'disc'}}>
                                    <li>Coaching Observation scores</li>
                                    <li>Previous month P4P results</li>
                                    <li>Attrition Risks</li>
                                    <li>Team Performance Review/Current month performance</li>
                                </ul>
                                </li>
                            </ul>
                            </li>
                        </ul>
                    </li>                    
                </ul>
            </div>
        </Dialog>
    );
}
export default CoachingGuidance;